import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import '../report-page.component.css';
import ButtonIcon from "../../../button";
import { ORFSelect, ORFDropdownCheckbox, ORFButton } from '../../../common/forms/order-request-form.component';

export class CostReportFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hideFilter: false,
            selectedRegions: [],
            selectedAllRegions: false,
            regions: [
                {
                    "Key": "APAC",
                    "Value": "APAC"
                },
                {
                    "Key": "NE",
                    "Value": "NE"
                },
                {
                    "Key": "AFRIKA",
                    "Value": "AFRIKA"
                },
                {
                    "Key": "LAT",
                    "Value": "LAT"
                },
                {
                    "Key": "ME",
                    "Value": "ME"
                },
                {
                    "Key": "SEE",
                    "Value": "SEE"
                },
                {
                    "Key": "WE",
                    "Value": "WE"
                },
                {
                    "Key": "NAM",
                    "Value": "NAM"
                },
                {
                    "Key": "India",
                    "Value": "India"
                },
                {
                    "Key": "China",
                    "Value": "China"
                }
            ],
            selectedCountries: [],
            selectedAllCountries: false,
            countries: [
                {
                    "Key": "Algeria",
                    "Value": "Algeria"
                },
                {
                    "Key": "Argentina",
                    "Value": "Argentina"
                },
                {
                    "Key": "Australia",
                    "Value": "Australia"
                },
                {
                    "Key": "Belgium",
                    "Value": "Belgium"
                },
                {
                    "Key": "Brazil",
                    "Value": "Brazil"
                },
                {
                    "Key": "Bulgaria",
                    "Value": "Bulgaria"
                },
                {
                    "Key": "Canada",
                    "Value": "Canada"
                },
                {
                    "Key": "China",
                    "Value": "China"
                },
                {
                    "Key": "Colombia",
                    "Value": "Colombia"
                },
                {
                    "Key": "Finland",
                    "Value": "Finland"
                },
                {
                    "Key": "France",
                    "Value": "France"
                },
                {
                    "Key": "Germany",
                    "Value": "Germany"
                },
                {
                    "Key": "Greece",
                    "Value": "Greece"
                },
                {
                    "Key": "Guatemala",
                    "Value": "Guatemala"
                },
                {
                    "Key": "Hong Kong",
                    "Value": "Hong Kong"
                },
                {
                    "Key": "Hungary",
                    "Value": "Hungary"
                },
                {
                    "Key": "India",
                    "Value": "India"
                },
                {
                    "Key": "Indonesia",
                    "Value": "Indonesia"
                },
                {
                    "Key": "Ireland",
                    "Value": "Ireland"
                },
                {
                    "Key": "Italy",
                    "Value": "Italy"
                },
                {
                    "Key": "Kenya",
                    "Value": "Kenya"
                },
                {
                    "Key": "Mexico",
                    "Value": "Mexico"
                },
                {
                    "Key": "New Zealand",
                    "Value": "New Zealand"
                },
                {
                    "Key": "Norway",
                    "Value": "Norway"
                },
                {
                    "Key": "Peru",
                    "Value": "Peru"
                },
                {
                    "Key": "Philippines",
                    "Value": "Philippines"
                },
                {
                    "Key": "Poland",
                    "Value": "Poland"
                },
                {
                    "Key": "Portugal",
                    "Value": "Portugal"
                },
                {
                    "Key": "Qatar",
                    "Value": "Qatar"
                },
                {
                    "Key": "Romania",
                    "Value": "Romania"
                },
                {
                    "Key": "Saudi Arabia",
                    "Value": "Saudi Arabia"
                },
                {
                    "Key": "Senegal",
                    "Value": "Senegal"
                },
                {
                    "Key": "Singapore",
                    "Value": "Singapore"
                },
                {
                    "Key": "Slovakia",
                    "Value": "Slovakia"
                },
                {
                    "Key": "South Korea",
                    "Value": "South Korea"
                },
                {
                    "Key": "Spain",
                    "Value": "Spain"
                },
                {
                    "Key": "Taiwan",
                    "Value": "Taiwan"
                },
                {
                    "Key": "Thailand",
                    "Value": "Thailand"
                },
                {
                    "Key": "United Kingdom",
                    "Value": "United Kingdom"
                },
                {
                    "Key": "Venezuela",
                    "Value": "Venezuela"
                },
                {
                    "Key": "Vietnam",
                    "Value": "Vietnam"
                }
            ],
            selectedVendors: [],
            selectedAllVendors: false,
            vendors: [
                {
                    "Key": "TIM - fn00kie (IT)",
                    "Value": "TIM - fn00kie (IT)"
                },
                {
                    "Key": "Au (JP)",
                    "Value": "Au (JP)"
                },
                {
                    "Key": "Proximus (BE)",
                    "Value": "Proximus (BE)"
                },
                {
                    "Key": "A1 Bulgaria (BG)",
                    "Value": "A1 Bulgaria (BG)"
                },
                {
                    "Key": "Optus (AU)",
                    "Value": "Optus (AU)"
                },
                {
                    "Key": "Orange (PL)",
                    "Value": "Orange (PL)"
                },
                {
                    "Key": "TIM - fAlu (IT)",
                    "Value": "TIM - fAlu (IT)"
                },
                {
                    "Key": "Orange (EG)",
                    "Value": "Orange (EG)"
                },
                {
                    "Key": "STC - fn00kie (SA)",
                    "Value": "STC - fn00kie (SA)"
                },
                {
                    "Key": "Claro (AR)",
                    "Value": "Claro (AR)"
                },
                {
                    "Key": "M1 (SG)",
                    "Value": "M1 (SG)"
                },
                {
                    "Key": "Taiwan Mobile - fn00kie (TW)",
                    "Value": "Taiwan Mobile - fn00kie (TW)"
                },
                {
                    "Key": "Bell Mobility (CA)",
                    "Value": "Bell Mobility (CA)"
                },
                {
                    "Key": "SingTel (SG)",
                    "Value": "SingTel (SG)"
                },
                {
                    "Key": "Softbank Mobile (JP)",
                    "Value": "Softbank Mobile (JP)"
                },
                {
                    "Key": "MTS St. Petersburg (RU)",
                    "Value": "MTS St. Petersburg (RU)"
                },
                {
                    "Key": "Telefonica (ES)",
                    "Value": "Telefonica (ES)"
                },
                {
                    "Key": "Airtel Fixed (IN)",
                    "Value": "Airtel Fixed (IN)"
                },
                {
                    "Key": "Movistar (CL)",
                    "Value": "Movistar (CL)"
                },
                {
                    "Key": "Movistar (CO)",
                    "Value": "Movistar (CO)"
                },
                {
                    "Key": "Smart (PH)",
                    "Value": "Smart (PH)"
                },
                {
                    "Key": "Three Ireland (Hutchison) (IE)",
                    "Value": "Three Ireland (Hutchison) (IE)"
                },
                {
                    "Key": "Claro - fn00kie (BR)",
                    "Value": "Claro - fn00kie (BR)"
                },
                {
                    "Key": "Hutchison 3 (ID)",
                    "Value": "Hutchison 3 (ID)"
                },
                {
                    "Key": "Chunghwa Telecom - fn00kie (TW)",
                    "Value": "Chunghwa Telecom - fn00kie (TW)"
                },
                {
                    "Key": "Rogers (CA)",
                    "Value": "Rogers (CA)"
                },
                {
                    "Key": "Turk Telekom - fn00kie (TR)",
                    "Value": "Turk Telekom - fn00kie (TR)"
                },
                {
                    "Key": "Everything Everywhere (GB)",
                    "Value": "Everything Everywhere (GB)"
                },
                {
                    "Key": "Orange (RO)",
                    "Value": "Orange (RO)"
                },
                {
                    "Key": "Verizon Wireless (US)",
                    "Value": "Verizon Wireless (US)"
                },
                {
                    "Key": "Airtel (IN)",
                    "Value": "Airtel (IN)"
                },
                {
                    "Key": "Vodafone (ES)",
                    "Value": "Vodafone (ES)"
                },
                {
                    "Key": "TIM (BR)",
                    "Value": "TIM (BR)"
                },
                {
                    "Key": "Telia Norge (NO)",
                    "Value": "Telia Norge (NO)"
                },
                {
                    "Key": "Cellcom - fn00kie (IL)",
                    "Value": "Cellcom - fn00kie (IL)"
                },
                {
                    "Key": "SFR (FR)",
                    "Value": "SFR (FR)"
                },
                {
                    "Key": "Maxis (MY)",
                    "Value": "Maxis (MY)"
                },
                {
                    "Key": "T-Mobile (AT)",
                    "Value": "T-Mobile (AT)"
                },
                {
                    "Key": "Cosmote (GR)",
                    "Value": "Cosmote (GR)"
                },
                {
                    "Key": "Comcel - fAlu (CO)",
                    "Value": "Comcel - fAlu (CO)"
                },
                {
                    "Key": "Telus Mobility (CA)",
                    "Value": "Telus Mobility (CA)"
                },
                {
                    "Key": "Telekom (SK)",
                    "Value": "Telekom (SK)"
                },
                {
                    "Key": "Movistar (PE)",
                    "Value": "Movistar (PE)"
                },
                {
                    "Key": "Vodafone (IN)",
                    "Value": "Vodafone (IN)"
                },
                {
                    "Key": "O2 (CZ)",
                    "Value": "O2 (CZ)"
                },
                {
                    "Key": "Entel (CL)",
                    "Value": "Entel (CL)"
                },
                {
                    "Key": "Claro (PE)",
                    "Value": "Claro (PE)"
                },
                {
                    "Key": "WIND - fAlu (IT)",
                    "Value": "WIND - fAlu (IT)"
                },
                {
                    "Key": "WIND - fn00kie (IT)",
                    "Value": "WIND - fn00kie (IT)"
                },
                {
                    "Key": "Tele2 (SE)",
                    "Value": "Tele2 (SE)"
                },
                {
                    "Key": "Oi (BR)",
                    "Value": "Oi (BR)"
                },
                {
                    "Key": "Vodafone (RO)",
                    "Value": "Vodafone (RO)"
                },
                {
                    "Key": "O2 (DE)",
                    "Value": "O2 (DE)"
                },
                {
                    "Key": "Vivo - fn00kie (BR)",
                    "Value": "Vivo - fn00kie (BR)"
                },
                {
                    "Key": "Turkcell - fAlu (TR)",
                    "Value": "Turkcell - fAlu (TR)"
                },
                {
                    "Key": "Turkcell - fn00kie (TR)",
                    "Value": "Turkcell - fn00kie (TR)"
                },
                {
                    "Key": "Vodafone (NZ)",
                    "Value": "Vodafone (NZ)"
                },
                {
                    "Key": "Personal (AR)",
                    "Value": "Personal (AR)"
                },
                {
                    "Key": "Vodafone (PT)",
                    "Value": "Vodafone (PT)"
                },
                {
                    "Key": "Movistar (EC)",
                    "Value": "Movistar (EC)"
                },
                {
                    "Key": "MTS Voronezh (RU)",
                    "Value": "MTS Voronezh (RU)"
                },
                {
                    "Key": "TeliaSonera S (SE)",
                    "Value": "TeliaSonera S (SE)"
                },
                {
                    "Key": "Vodafone - fAlu (TR)",
                    "Value": "Vodafone - fAlu (TR)"
                },
                {
                    "Key": "Swisscom Mobile (CH)",
                    "Value": "Swisscom Mobile (CH)"
                },
                {
                    "Key": "Vodafone (GB)",
                    "Value": "Vodafone (GB)"
                },
                {
                    "Key": "Salt (CH)",
                    "Value": "Salt (CH)"
                },
                {
                    "Key": "AT&T (US)",
                    "Value": "AT&T (US)"
                },
                {
                    "Key": "Beeline Moscow (RU)",
                    "Value": "Beeline Moscow (RU)"
                },
                {
                    "Key": "Vodafone - fn00kie (TR)",
                    "Value": "Vodafone - fn00kie (TR)"
                },
                {
                    "Key": "Vivo - fAlu (BR)",
                    "Value": "Vivo - fAlu (BR)"
                },
                {
                    "Key": "PTC/T-Mobile (PL)",
                    "Value": "PTC/T-Mobile (PL)"
                },
                {
                    "Key": "Vodafone (GR)",
                    "Value": "Vodafone (GR)"
                },
                {
                    "Key": "CNT (EC)",
                    "Value": "CNT (EC)"
                },
                {
                    "Key": "Claro - fn00kie (EC)",
                    "Value": "Claro - fn00kie (EC)"
                },
                {
                    "Key": "Claro - fAlu (EC)",
                    "Value": "Claro - fAlu (EC)"
                },
                {
                    "Key": "Bouygues - fAlu (FR)",
                    "Value": "Bouygues - fAlu (FR)"
                },
                {
                    "Key": "Spark (NZ)",
                    "Value": "Spark (NZ)"
                },
                {
                    "Key": "WIND (GR)",
                    "Value": "WIND (GR)"
                },
                {
                    "Key": "O2 (GB)",
                    "Value": "O2 (GB)"
                },
                {
                    "Key": "Globe (PH)",
                    "Value": "Globe (PH)"
                },
                {
                    "Key": "GT - fAlu (TW)",
                    "Value": "GT - fAlu (TW)"
                },
                {
                    "Key": "GT - fn00kie (TW)",
                    "Value": "GT - fn00kie (TW)"
                },
                {
                    "Key": "Megafon Samara (RU)",
                    "Value": "Megafon Samara (RU)"
                },
                {
                    "Key": "Megafon Belgorod (RU)",
                    "Value": "Megafon Belgorod (RU)"
                },
                {
                    "Key": "Vodafone (DE)",
                    "Value": "Vodafone (DE)"
                },
                {
                    "Key": "PT Empresas (PT)",
                    "Value": "PT Empresas (PT)"
                },
                {
                    "Key": "Starhub (SG)",
                    "Value": "Starhub (SG)"
                },
                {
                    "Key": "MTS Krasnodar (RU)",
                    "Value": "MTS Krasnodar (RU)"
                },
                {
                    "Key": "AIS (TH)",
                    "Value": "AIS (TH)"
                },
                {
                    "Key": "Vodafone (EG)",
                    "Value": "Vodafone (EG)"
                },
                {
                    "Key": "T-Mobile (US)",
                    "Value": "T-Mobile (US)"
                },
                {
                    "Key": "Telenor (DK)",
                    "Value": "Telenor (DK)"
                },
                {
                    "Key": "Orange (FR)",
                    "Value": "Orange (FR)"
                },
                {
                    "Key": "Polkomtel/Plus (PL)",
                    "Value": "Polkomtel/Plus (PL)"
                },
                {
                    "Key": "NOS (PT)",
                    "Value": "NOS (PT)"
                },
                {
                    "Key": "Telstra (AU)",
                    "Value": "Telstra (AU)"
                },
                {
                    "Key": "Telia Sonera (FI)",
                    "Value": "Telia Sonera (FI)"
                },
                {
                    "Key": "Verizon Data (US)",
                    "Value": "Verizon Data (US)"
                },
                {
                    "Key": "Verizon Voice (US)",
                    "Value": "Verizon Voice (US)"
                },
                {
                    "Key": "AT&T Voice and Data (US)",
                    "Value": "AT&T Voice and Data (US)"
                },
                {
                    "Key": "Verizon Voice and Data (US)",
                    "Value": "Verizon Voice and Data (US)"
                },
                {
                    "Key": "Equinix Data (US)",
                    "Value": "Equinix Data (US)"
                },
                {
                    "Key": "Softbank Network (JP)",
                    "Value": "Softbank Network (JP)"
                },
                {
                    "Key": "AT&T Mobility (US)",
                    "Value": "AT&T Mobility (US)"
                },
                {
                    "Key": "Zayo Group Data (US)",
                    "Value": "Zayo Group Data (US)"
                }
            ],
            months: [
                {
                    "Key": "October 2021",
                    "Value": "October 2021"
                },
                {
                    "Key": "November 2021",
                    "Value": "November 2021"
                },
                {
                    "Key": "December 2021",
                    "Value": "December 2021"
                },
                {
                    "Key": "January 2022",
                    "Value": "January 2022"
                },
                {
                    "Key": "February 2022",
                    "Value": "February 2022"
                },
                {
                    "Key": "March 2022",
                    "Value": "March 2022"
                },
                {
                    "Key": "April 2022",
                    "Value": "April 2022"
                }
            ],
            topResultOption: [
                {
                    "Key": "Top 5",
                    "Value": "Top 5"
                },
                {
                    "Key": "Top 10",
                    "Value": "Top 10"
                },
                {
                    "Key": "Top 15",
                    "Value": "Top 15"
                },
                {
                    "Key": "Top 20",
                    "Value": "Top 20"
                }
            ]
        }
    }

    onCheckDropdown = (e) => {
        const { selectedRegions, selectedAllRegions, regions } = this.state;
        const target = e.target;
        const value = target.value;
        let newSelectedValues = [];

        if ((this.getAllValues(regions).find(x => x === value) == undefined)) {
            newSelectedValues = selectedAllRegions ? [] : this.getAllValues(regions);
        } else {
            newSelectedValues = this.updateSelectedValues(value, selectedRegions);
        }

        this.setState({
            selectedAllRegions: newSelectedValues.length == regions.length,
            selectedRegions: newSelectedValues
        });
    }


    getKeyByValue = (object, value) => {
        return object.find(o => o.Value === value).Key;
    }
    getAllValues = (objects) => {
        var newList = [];
        objects.forEach(function (obj) {
            newList.push(obj.Value);
        })
        return newList;
    }

    getAllKeys = (objects) => {
        var newList = [];
        objects.forEach(function (obj) {
            newList.push(obj.Key);
        })
        return newList;
    }

    updateSelectedValues = (v, options) => {

        var newFilter = [...options];
        if (options.some((value) => value === v)) {
            newFilter = newFilter.filter((val) => val !== v);
        } else {
            newFilter.push(v);
        }

        return newFilter
    }

    showHideFilter = (e, v) => {
        this.setState({
            hideFilter: !v,
        });
    }


    render() {
        const { topResultOption, months, regions, selectedRegions, selectedAllRegions, hideFilter
            , countries, selectedCountries, selectedAllCountries
            , vendors, selectedVendors, selectedAllVendors
        } = this.state;

        return (
            <div className="component-container legend-center second-col-container">
               
                <div className="order-filter-header-container">
                    <div>
                        <h2 className="report-header-label">
                            Cost Report
                        </h2>
                    </div>
                    <div className="order-filter-header-right">
                        <div  className="order-filter-header-right-content">
                           <h1 className="order-filter-week-label">  Current Month June 2021 </h1>
                        </div>
                        <div className="order-filter-header-right-content">
                            <ButtonIcon onClick={() => alert("click")} iconLeft="file-pdf" iconSize="14px" customClassName="pdf-button" labelName="Customize Report" />
                        </div>
                        <div className="order-filter-header-right-content">
                            <ButtonIcon onClick={() => alert("click")} iconLeft="file-pdf" iconSize="14px" customClassName="pdf-button" labelName="Export File" />
                        </div>
                        <div className="order-filter-header-right-content">
                            <span className="order-filter-header-link" onClick={e => this.showHideFilter(e, hideFilter)}>{hideFilter ? "Show" : "Hide"} Filter</span>
                        </div>                    
                    </div>
                </div>
                <div hidden={hideFilter} className="order-filter-list-container">
                    <div className="order-filter-list-item-container">
                         <ORFDropdownCheckbox
                            className="form-control"
                            label={"Region"}
                            options={regions}
                            placeholder={"Select Region"}
                            fieldName='model.region'
                            action={this.onCheckDropdown}
                            selectedValues={selectedRegions}
                            isSelectAll={selectedAllRegions}
                        />
                    </div>
                    <div className="order-filter-list-item-container">
                         <ORFDropdownCheckbox
                            className="form-control"
                            label={"Country"}
                            options={countries}
                            placeholder={"Select Countries"}
                            fieldName='model.region'
                            action={this.onCheckDropdown}
                            selectedValues={selectedCountries}
                            isSelectAll={selectedAllCountries}
                        />
                    </div>                 
                    <div className="order-filter-list-item-container">
                        <ORFDropdownCheckbox
                            className="form-control"
                            label={"Vendor"}
                            options={vendors}
                            placeholder={"Select Vendors"}
                            fieldName='model.region'
                            action={this.onCheckDropdown}
                            selectedValues={selectedVendors}
                            isSelectAll={selectedAllVendors}
                        />
                    </div>
                    <div className="order-filter-list-item-container">
                         <ORFSelect
                            className="form-control"
                            label={"Select Top"}
                            options={topResultOption}
                            placeholder={""}
                            fieldName='model.region'
                        />
                    </div>
                    <div className="order-filter-list-item-container">
                         <ORFSelect
                            className="form-control"
                            label={"Month From"}
                            options={months}
                            placeholder={""}
                            fieldName='model.region'
                        />
                    </div>
                    <div className="order-filter-list-item-container">
                        <ORFSelect
                            className="form-control"
                            label={"Month To"}
                            options={months}
                            placeholder={""}
                            fieldName='model.region'
                        />
                    </div>
                    <div className="order-filter-list-item-button-container">
                        <ORFButton
                            label={"Reset"}
                            variant={"outline-secondary"}
                        />
                    </div>
                    <div className="order-filter-list-item-button-container">
                        <ORFButton
                            label={"Apply Filter"}
                            variant={"primary"}
                        />
                    </div>
                </div>               
            </div>
        )
    }
}
